import styled from 'styled-components';
import {useToast} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {useCommunitySubscribe} from "../api/communities";
import useFeedback from "../utils/use_feedback";
import trim from "../utils/trim";
import {themecolors} from "../utils/themecolors";
import {useBaseCommunity, useLoggedIn, useStoreProfile} from "../store";
import useModal from "../modals";
import {BareButton} from "./button";
import Sheet from "./bottom-sheet/sheet";
import AboutCommunitySheet from "./bottom-sheet/about_community";
import CommunityFeedMenu from "./community_feed_menu";
import PostSortSheet from "./bottom-sheet/post_sort";

const Header = styled.div``;
const About = styled.div``;
const CommunityIcon = styled.div``;
const Text = styled.div``;
const DisplayName = styled.div``;
const Description = styled.div``;
const FullDescription = styled.div``;
const Details = styled.div``;
const Subscribe = styled.div``;
const SubscribeButton = styled.div``;
const Buttons = styled.div``;
const InfoButton = styled.div``;
const TextDiv = styled.div``;
const SecondLine = styled.div``;
const DisplayNameInner = styled.div``;

const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CommunityHeader = styled(({ className, community, sort, refresh, feedKey, feedId, feedName, pageType }) => {

    const [sortOpen, setSortOpen] = useState(false);
    const handleSort = async () => {
        setSortOpen(true);
    }

    const [activeTab, setActiveTab] = useState(pageType);
    const tabs = ["Hot Posts", "About", "Rules"];

    const loggedIn = useLoggedIn();
    const history = useHistory();
    const { theme } = useStoreProfile();
    const feedback = useFeedback();
    const subscribe = useCommunitySubscribe(feedback.channel);
    const toast = useToast();
    const baseCommunity = useBaseCommunity().toLowerCase();
    const handleSubscribe = async () => {
        try {
            await subscribe([community.name]);
        } catch {
            toast({
                title: `Failed to subscribe.`,
                status: 'error',
                isClosable: true,
            });
        }
    };
    const handleSignup = async () => {
        history.push('/registration');
    };
    const isBaseCommunity = baseCommunity === community?.name?.toLowerCase();

    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const modal = useModal();
    const [aboutOpen, setAboutOpen] = useState(false);
    const handleCommunityOptions = () => setAboutOpen(true);

    const [expand, setExpand] = useState(false);
    const handleExpand = () => setExpand(!expand);

    const DescriptionText = expand ? FullDescription : Description;

    useEffect(() => {
        switch (activeTab) {
            case "About":
                break;
            case "Rules":
                break;
            case "Related":
                break;
            default:
                break;
        }
    }, [activeTab]);

    return (
        <div className={className}>
            <Header />

            <About>
                <CommunityIcon>
                    <img src={community.icon ? `https://img.scored.co/community/${community.name.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage} />
                </CommunityIcon>
                <Buttons>
                    {((isBaseCommunity && community && !loggedIn)) &&
                    <Subscribe>
                        <SubscribeButton variant={community.is_subscribed ? 'subscribed' : 'subscribe'} onClick={handleSignup}>
                            Sign Up
                        </SubscribeButton>
                    </Subscribe>
                    }
                    {((!isBaseCommunity && community) || loggedIn) &&
                    <Subscribe>
                        <SubscribeButton variant={community.is_subscribed ? 'subscribed' : 'subscribe'} onClick={handleSubscribe}>
                            {community.is_subscribed ? 'Joined' : 'Join'}
                        </SubscribeButton>
                    </Subscribe>
                    }
                </Buttons>
                <Text>
                    <Details>
                        <TextDiv>
                            <DisplayName>
                                <DisplayNameInner>
                                    {community?.display_name && trim(community.display_name, 24)}
                                </DisplayNameInner>
                            </DisplayName>
                        </TextDiv>
                    </Details>
                    <DescriptionText style={{ marginTop: 8, marginBottom: 8 }} onClick={handleExpand}>
                        {community ? (community.description ? community.description : 'No description found.') : ''}
                    </DescriptionText>
                </Text>
            </About>

            <CommunityFeedMenu setSortOpen={setSortOpen} sort={sort} activeTab={activeTab} setActiveTab={setActiveTab}
                               tabs={tabs} community={community.name} />

            {aboutOpen && <Sheet onClose={() => setAboutOpen(false)} padding={"menu"}><AboutCommunitySheet community={community.name} /></Sheet>}
            {sortOpen && <Sheet onClose={() => setSortOpen(false) } padding={"menu"}><PostSortSheet onClose={() => setSortOpen(false) } sort={sort} refresh={refresh} feedKey={feedKey} feedId={feedId} feedName={feedName} community={community.name} /></Sheet>}

        </div>
    );
})`
  ${Header} {
    height: 72px;
    background-image: url(${({ community }) => community.header});
    background-color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#bfbfbf'};
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${About} {
    width: 100%;
    background-color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_background_1 : theme.white_0};
  }

  ${CommunityIcon} {
    position: absolute;
    margin-top: -36px;
    margin-left: 12px;
  }

  ${CommunityIcon} img {
    width: 64px;
    height: 64px;
    background-color: #b2b2b2;
    border-radius: 50%;
    border: 3px solid ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

  ${Text} {
    padding: 2px 16px 0px 16px;
  }

  ${DisplayName} {
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    white-space: nowrap;
    overflow: hidden;
    margin-top: 8px;
  }
  ${DisplayNameInner} {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ${SecondLine} {
    font-size: 15px;
    color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${TextDiv} {
    line-height: 22px;
    flex: 1;
    min-width: 0;
  }

  ${FullDescription} {
    font-size: 14px;
    color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  ${Description} {
    font-size: 14px;
    color: ${({ theme }) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ${Details} {
    display: flex;
    align-items: center;
  }

  ${Buttons} {
    margin-left: auto;
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding: 0 16px;
  }
  
  ${InfoButton} {
    margin-right: 12px;
  }
  
  ${Subscribe} {
    margin-left: auto;
  }
  ${Subscribe} ${BareButton} {
    ${({theme, community}) => community.is_subscribed ?
    `background-color: transparent;
             color: ${theme.color.name === 'dark' ? theme.white_0 : '#2568bd'};`
    :
    `background-color: ${theme.color.name === 'dark' ? theme.white_0 : '#2568bd'};
             color: ${theme.color.name === 'dark' ? themecolors.light_high_impact_text : theme.white_0};`
}
    font-size: 14px;
    padding: 8px 0;
    border-radius: 6px;
    font-weight: 500;
    width: 106px;
  }

  ${SubscribeButton} {
    font-size: 14px;
    font-weight: 600;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.pure_black};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_black : themecolors.pure_white};
    padding: 4px 16px;
    border-radius: 48px;
  }
`;

export default CommunityHeader;
